import React from "react";
import Layout from "@/components/layout/Layout";
import styles from './Styles.module.scss';
import BackButton from "@/components/button/back/BackButton";
import classNames from 'classnames/bind';
import BlockContent from "@sanity/block-content-to-react";
import TrendingNow from "@/components/trendingNow/TrendingNow";
import BreadcrumbSchema from "@/components/schema/BreadcrumbSchema";

const cx = classNames.bind(styles);

export default function AboutUs({body}) {

  const serializers = {
    types: {},
    marks: {link: ({mark, children}) => <a href={mark.href}>{children}</a>}
  }

  const renderBlockContent = (node) => {
    if (!node) {
      return undefined;
    }
    if (Array.isArray(node)) {
      return node.map(renderBlockContent);
    }
    const serializer = serializers.types[node._type];
    return serializer
        ? serializer({node})
        : <BlockContent key={node._key}
                        blocks={node}
                        serializers={serializers}/>;
  }

  return (
      <Layout nav>
        <BreadcrumbSchema crumbs={[{name: "About Us", path: "about-us"}]}/>
        <div className={cx(styles.container)}>
          <section className={styles.section}>
            <div className={styles.back}>
              <BackButton className={styles.back}/>
            </div>
            <div className={styles.head}>
              <h1>ABOUT US</h1>
            </div>
          </section>
          <div className={styles.articlesContainer}>
            <div className={styles.body}>
              {renderBlockContent(body)}
            </div>
          </div>

          {/* Trending now pages*/}

          <div>
            <div className={styles.trendingHeader}>
              <h2>Trending Now</h2>
            </div>
            <TrendingNow className={styles.trendingNow}/>
          </div>
        </div>
      </Layout>
  )
}
